export default __webpack_public_path__ + "static/media/FAQs.ee31916e.svg";